import { SxProps, Theme } from "@mui/system";
import colors from "../../theme/Colours";

/**
 Centralized style objects for CustomDialog
 Exported items:
  - dialogPaperSx: PaperProps.sx for Dialog
  - closeBoxSx: sx for the top-right close icon wrapper container
  - outerPaddingSx: sx for the Box wrapping the table (controls divider gaps)
  - tableContainerSx: sx for TableContainer
  - tableSx: sx for Table
  - headerCellSx: sx for TableHead cells
  - getBodyCellSx(isLast): helper returning sx for TableBody cells (depends on isLast)
  - clampTwoLines: typography clamp styles (used for both columns)
 */

export const dialogPaperSx: SxProps<Theme> = {
  borderRadius: 4,
  padding: 0,
};

export const closeBoxSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  px: 8,
  py: 2,
};

export const outerPaddingSx: SxProps<Theme> = {
  px: 6,
  pb: 4,
};

export const tableContainerSx: SxProps<Theme> = {
  boxShadow: "none",
  background: "transparent",
};

export const tableSx: SxProps<Theme> = {
  width: "100%",
  tableLayout: "fixed" as const,
  borderCollapse: "separate",
};

export const headerCellSx: SxProps<Theme> = {
  align: "center",
  fontWeight: 600,
  color: colors.paginationCaption,
  py: 2,
  borderBottom: "none",
  px: 0,
};

export const clampTwoLines: SxProps<Theme> = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "normal",
  wordBreak: "break-word",
};

/**
 * body cell sx - dynamic because bottom border is removed for last row
 * @param isLast whether this is the last row
 */
export const getBodyCellSx = (isLast: boolean): SxProps<Theme> => {
  const rowBorder = isLast ? "none" : "1px solid rgba(0,0,0,0.08)";
  return {
    py: 2,
    borderBottom: rowBorder,
    px: 0,
  };
};
